import { observable, action} from 'mobx';
import _ from 'lodash';

const initialTeaserOddsPageData = {
    teaserType: {},
    teaserLeagues: {},
    teasersTypes: {},
    teaserEvents: [],
    teaserPoint: {},
    isExpandTeaserType: false,
    isExpandTeaserPoint: false
}

export default class OddspageStore {

    @observable fgData = [];
    @observable oddspageContent = "";
    @observable oddsPageData = {};
    @observable teaserOddsPageData = initialTeaserOddsPageData;
    @observable leaguesPageData = {};
    @observable oddsPageInitData = {};
    @observable liveGamesPageData = {};
    @observable liveGamePageInitData = {};

    @observable featuredGamesInitData = {};
    @observable featuredGamesData = {};

    @observable isTeaserHandicap = true;

    @action setTeaserHandicap(isHandicap) {
        this.isTeaserHandicap = isHandicap
    }

    @action setOddspageContent(newContent) {
      this.oddspageContent = newContent;
  }

    updateFeaturedGamesInitData(newData) {
        this.featuredGamesInitData = newData
    }

    updateFeaturedGamesData(newData) {
        this.featuredGamesData = newData
    }

    updateLiveGamesPageInitData(newData) {
        this.liveGamePageInitData = newData;
    }

    updateLiveGamesPageData(newData) {
        this.liveGamesPageData = newData;
    }

    updateLeaguesPageData(newData) {
        this.leaguesPageData = newData
    }

    updateOddsPageData(newData) {
        this.oddsPageData = newData
    }

    updateTeaserOddsPageData(newData) {
        this.teaserOddsPageData = newData
    }

    updateOddsPageInitData(newData) {
        this.oddsPageInitData = newData
    }

    updateFGData(newData) {
        this.fgData = newData;
    }

    resetTeaserOddsPageData() {
        this.teaserOddsPageData = initialTeaserOddsPageData
    }
}


// WEBPACK FOOTER //
// ./src/app/stores/OddspageStore.js